import { Exchange, Operation, OperationResult, mapExchange } from "@urql/next"

interface LoadingCallbacks {
  incrementLoading: () => void
  decrementLoading: () => void
}

export const loadingExchange = (callbacks: LoadingCallbacks): Exchange => {
  const operationMap = new Set<string>()

  return mapExchange({
    onOperation(operation: Operation) {
      // Only track queries and mutations, not subscriptions
      if (operation.kind === "query" || operation.kind === "mutation") {
        const operationId = `${operation.kind}-${operation.key}`

        // Prevent duplicate tracking
        if (!operationMap.has(operationId)) {
          operationMap.add(operationId)
          try {
            callbacks.incrementLoading()
          } catch (error) {
            console.error("Loading increment error:", error)
            operationMap.delete(operationId)
          }
        }
      }
    },
    onResult(result: OperationResult) {
      // Decrement on completion
      if (
        result.operation.kind === "query" ||
        result.operation.kind === "mutation"
      ) {
        const operationId = `${result.operation.kind}-${result.operation.key}`

        if (operationMap.has(operationId)) {
          operationMap.delete(operationId)
          try {
            callbacks.decrementLoading()
          } catch (error) {
            console.error("Loading decrement error:", error)
          }
        }
      }
    },
    onError(error, operation: Operation) {
      // Ensure decrement on error as well
      if (operation.kind === "query" || operation.kind === "mutation") {
        const operationId = `${operation.kind}-${operation.key}`

        if (operationMap.has(operationId)) {
          operationMap.delete(operationId)
          try {
            callbacks.decrementLoading()
          } catch (callbackError) {
            console.error("Loading decrement error:", callbackError)
          }
        }
      }
    },
  })
}
